module.exports = __webpack_public_path__ + "39c6cc8c734c925c7a4a1fcadfe41e2e.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-66@2x.png
// module id = 530
// module chunks = 0